define(function (require) {
    "use strict";

    var TicketsSnippetsCompositeModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketsSnippetsCompositeModel = Backbone.Model.extend({
        });
    });
    return TicketsSnippetsCompositeModel;
});
